var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('canvas',{ref:"canvas",attrs:{"tabindex":"1"},on:{"keydown":_vm.onCanvasKeydown,"click":_vm.onCanvasClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }